import React, { Component } from "react";
import swal from "@sweetalert/with-react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import Select from "react-select";
import ActivityLogs from "../../ShortCutComponents/ActivityLogs";
import NumberFormat from "react-number-format";
import { checkPermission } from "../../../../Helper";
// import moment from "moment";
import PermissionModal from "../../ShortCutComponents/PermissionModal";
import "./myReactSelect.css";
import {
  Button,
  // CardHeader,
  Col,
  Form,
  // Row,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormGroup,
  Label,
} from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Modal } from "react-bootstrap";
import "./baseForms.css";
import "react-datepicker/dist/react-datepicker.css";
// import DatePicker from "react-datepicker";
import "./formsTable.css";
import axios from "axios";
import { baseurl } from "../../../../baseurl.js";
import { Redirect } from "react-router-dom";

var thisContex;
var token = localStorage.getItem("token");
var username = localStorage.getItem("username");
var companySymbolCurrency = localStorage.getItem("companySymbolCurrency");

function dueFormatorsComma(cell, row, enumObject, index) {
  let newCell = "";
  newCell = cell.toLocaleString("en-US", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
  // return newCell;
  newCell = companySymbolCurrency + " " + newCell;
  return <div>{newCell}</div>;
}

function dueFormatorsText(cell, row, enumObject, index) {
  let newCell = cell;

  return <div>Payment to {newCell}</div>;
}
// const handleSubmitAddEmployee = (event) => {
//   event.preventDefault();
//   const {
//     employeeFirstName,
//     employeeLasName,
//     employeStartDate,
//     employeEndDate,
//     employeeAddress,
//     customerNameBank,
//   } = thisContex.state;
//   let companyId = localStorage.getItem("companyId");
//   event.preventDefault();

//   axios
//     .post(
//       `${baseurl}/masterData/getAddEmployee`,
//       {
//         employeeFirstName: employeeFirstName,
//         employeeLasName: employeeLasName,
//         employeStartDate: employeStartDate,
//         employeEndDate: employeEndDate,
//         employeeAddress: employeeAddress,
//         companyId: companyId,
//         username: username,
//       },
//       {
//         headers: {
//           authorization: token,
//         },
//       }
//     )
//     .then(function (response) {
//       console.log(response);

//       swal({
//         title: "Saved Successfully!",
//         text: "Item Add",
//         icon: "success",
//       }).then((value) => {
//         // thisContex.getData();
//         // thisContex.addToggle();
//       });
//     })
//     .catch(function (error) {
//       console.log(error);
//     });
// };
// function indexN(cell, row, enumObject, index) {
//   return <div>{index + 1}</div>;
// }
let companyId = localStorage.getItem("companyId");
let currencyId = localStorage.getItem("currencyId");
class OverviewEmployeeExpenses extends Component {
  constructor(props) {
    super(props);

    this.toggleAddNew = this.toggleAddNew.bind(this);
    //this.handleSubmitAddEmployee = this.handleSubmitAddEmployee.bind(this);

    this.handleSubmitEdit = this.handleSubmitEdit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeEdit = this.handleChangeEdit.bind(this);

    ////////////////////////

    this.addToggle = this.addToggle.bind(this);

    // this.table = data.rows;
    this.state = {
      showModalAddNew: false,
      data: [],
      employeeFirstName: "",
      employeeLasName: "",
      employeStartDate: "",
      employeEndDate: "",
      permission: true,
      rolesPermission: false,
      journalId: "",
      showModalOpen: false,
      employeeAddress: [],
      isLoadedTableData: false,
      showModalUpdate: false,
    };
    thisContex = this;
  }

  setDelete = (row) => {
    let rowId = row.emp_pay_id;
    let jr_id = row.journal_id;

    let tempThis = this;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(
            `${baseurl}/empPayment/deleteEmployeeExpense`,
            {
              username: username,
              id: rowId,
              journalId: jr_id,
              companyId: companyId,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then((response) => {
            Swal.fire("Deleted!", "Your Record has been deleted.", "success");
            tempThis.getData();
          })
          .catch((err) => {
            console.log(err);
            swal({
              title: "Failed!",
              text: "Internet Problem",
              icon: "error",
              button: "Try Again!",
            });
          });
      }
    });
  };
  // redirectToOrder = (cell, row) => {
  //   console.log(row);
  //   if (cell === "update") {
  //     this.setState({
  //       redirect: true,
  //       id: row.PAY_EMPLOYEE_ID,
  //       updateCheck: 0,
  //     });
  //   }
  // };
  handleSubmitEdit(event) {
    event.preventDefault();

    const {
      idUpdate,
      employee,
      employeStartDate,
      pay,
      bank,
      remarks,
      journalId,
    } = this.state;
    let Id = idUpdate;

    axios
      .post(
        `${baseurl}/empPayment/getPayEmployeeUpdate`,
        {
          id: Id,
          employee: employee.id,
          employeName: employee.label,
          employeStartDate,
          pay: pay.toString().replaceAll(",", ""),
          bank: bank.id,
          companyId: companyId,
          journalId: journalId,
          currencyId: currencyId,
          remarks,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )

      .then(function (response) {
        swal({
          title: "Success!",
          text: "Update!",
          icon: "success",
        }).then((value) => {
          thisContex.updateModalToggle();
          thisContex.getData();
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  showUpdateModal = (row) => {
    let idUpdate = row.emp_pay_id;
    this.setState({
      showModalUpdate: true,
      idUpdate,
    });
    // this.updateModalToggle();

    // axios
    //   .post(
    //     `${baseurl}/empPayment/getEmployeeReimbureUpdateData`,
    //     { username: username, id: tableId },
    //     {
    //       headers: {
    //         authorization: token,
    //       },
    //     }
    //   )
    //   .then(function (response) {
    //     let withIdData = response.data.data;
    //     let firstN;
    //     let amount;
    //     let name;
    //     let bank;
    //     let bankID;
    //     let bankname;
    //     let remarks;
    //     let pay_date;
    //     // let journalId;
    //     let idUpdate = -1;

    //     firstN = withIdData[0]["Employee_Id"];
    //     amount = withIdData[0]["amount"];
    //     name = withIdData[0]["NAME"];
    //     idUpdate = withIdData[0]["emp_pay_id"];
    //     bankID = withIdData[0]["id"];
    //     bank = withIdData[0]["bank_acct_id"];
    //     bankname = withIdData[0]["label"];
    //     pay_date = withIdData[0]["pay_date"];
    //     remarks = withIdData[0]["remarks"];
    //     //journalId = withIdData[0]["journal_id"];

    //     let todayDate = new Date();
    //     todayDate = moment(pay_date).format("YYYY-MM-DD");

    //     let objCustomer = {
    //       id: firstN,
    //       label: name,
    //     };

    //     let objCustomerbank = {
    //       id: bankID,
    //       label: bankname,
    //     };

    //     thisContex.setState({
    //       employee: objCustomer,
    //       customerName: objCustomer.label,
    //       pay: amount,
    //       bank: objCustomerbank,
    //       customerNameBank: objCustomerbank.label,
    //       employeStartDate: todayDate,
    //       journalId: withIdData[0]["journal_id"],

    //       idUpdate,
    //       remarks,
    //     });
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
  };
  toggleActivityModel = (row) => {
    console.log("row :>> ", row);
    this.setState({
      activityModelIsOpen: !this.state.activityModelIsOpen,
      getActivityByDocNo: row,
    });
  };
  updateModalToggle = () => {
    this.setState({
      UpdateModal: !this.state.UpdateModal,
    });
  };
  orderDetHandler = (cell, row) => {
    return (
      <div>
        <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            color="warning"
            disabled={this.state.rolesPermission ? true : false}
            onClick={() => {
              this.toggleActivityModel(row);
            }}
          >
            Activity
          </Button>
        </span>
        <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            color="primary"
            onClick={() => this.showUpdateModal(row)}
            disabled={thisContex.state.rolesPermission}
            // onClick={() => {
            //   this.redirectToOrder("update", row);
            // }}
          >
            Edit
          </Button>
        </span>
        <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            color="danger"
            disabled={thisContex.state.rolesPermission}
            onClick={() => this.setDelete(row)}
          >
            Delete
          </Button>
        </span>
        <span></span>
      </div>
    );
  };
  toggleAddNew = () => {
    this.setState({ showModalAddNew: !this.state.showModalAddNew });
  };
  toggleOpen = () => {
    this.setState({ showModalOpen: !this.state.showModalOpen });
  };
  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  handleChangeEdit(event) {
    this.setState({
      // Computed property names
      // keys of the objects are computed dynamically
      [event.target.name]: event.target.value,
    });
  }
  handleChangeLovsSelect = (employee) => {
    this.setState({
      employee,
      employeeFirstName: employee?.label,
    });
  };
  handleChangeLovsSelectBank = (bank) => {
    thisContex.setState({
      bank,
      customerNameBank: bank?.label,
    });
  };

  addToggle = () => {
    this.setState({
      itemAdd: "",
    });
    this.toggleAddNew();
  };
  showDetailsModel = (cell) => {
    this.toggleOpen();
  };
  async componentDidMount() {
    await this.asyncRollCheck();
    if (this.state.permission) {
      this.getData();
    }
  }
  asyncRollCheck = async () => {
    let rolId = 3;
    let adminRoleId = 1;
    let readYn = 1;
    let writeYn = 0;
    let formType = "OverView";

    let empId = localStorage.getItem("employeeId");
    let makeTrueFlase = "";
    //ye localStorage se lani h login k wqt
    let permissionFunction = await checkPermission(
      empId,
      adminRoleId,
      rolId,
      readYn,
      writeYn,
      formType
    );
    //permission = permission[0];
    console.log(
      "gggggggg",
      permissionFunction[0],
      " ",
      permissionFunction[1],
      " ",
      permissionFunction[2]
    );
    const p1 = Number(permissionFunction[1]);
    const p2 = Number(permissionFunction[2]);

    if (p1 === 1 && p2 === 0) {
      makeTrueFlase = true;
    } else {
      makeTrueFlase = false;
    }

    // console.log("a", a);
    this.setState({
      permission: permissionFunction[0],
      rolesPermission: makeTrueFlase,
      //showPermissionModal: false,
      //showPermissionModal: permission ? false : true,
    });
  };
  getData() {
    axios
      .post(
        `${baseurl}/empPayment/getPayEmployeeExpenses`,

        { username: username, companyId: companyId },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data.data);
        let getItemData = res.data.data;

        //Storing users detail in state array object
        this.setState({
          isLoadedTableData: true,
          tableData: getItemData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .post(
        `${baseurl}/lovs/getBankCash`,
        { username: username, companyId: companyId },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        let mydatabank = [];
        let responseData = response.data.data;
        for (let loop = 0; loop < responseData.length; loop++) {
          mydatabank.push({
            id: responseData[loop]["id"],
            label: responseData[loop]["label"],
          });
        }
        console.log(mydatabank);
        thisContex.setState({
          bankCash: mydatabank,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
    axios
      .post(
        `${baseurl}/empPayment/getPayEmployee`,
        { username: username, companyId: companyId },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        let mydata = [];
        let responseData = response.data.data;
        for (let loop = 0; loop < responseData.length; loop++) {
          mydata.push({
            id: responseData[loop]["PAY_EMPLOYEE_ID"],
            label: responseData[loop]["NAME"],
          });
        }

        thisContex.setState({
          clientLov: mydata,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  render() {
    const {
      tableData,
      isLoadedTableData,
      // itemAdd,
      employee,
      getActivityByDocNo,
      clientLov,
      pay,
      activityModelIsOpen,
      bank,
      remarks,
      bankCash,

      employeStartDate,
    } = this.state;

    const options = {
      paginationShowsTotal: true,
      page: 1,
      sizePerPage: 5,
      pageStartIndex: 1,
      paginationSize: 5,
      prePage: "Prev",
      nextPage: "Next",
      firstPage: "First",
      lastPage: "Last",
      prePageTitle: "Go to previous",
      nextPageTitle: "Go to next",
      firstPageTitle: "Go to first",
      lastPageTitle: "Go to Last",
      paginationPosition: "top",
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "20",
          value: 20,
        },
        {
          text: "30",
          value: 30,
        },
        {
          text: "All",
        },
      ],
    };
    if (!this.state.permission) {
      return <PermissionModal moduleName="Purchase" />;
    } else if (this.state.showModalUpdate) {
      return (
        <Redirect
          push
          to={{
            pathname: "/EmployeeReimburse",
            state: {
              id: this.state.idUpdate,
              updateCheck: 2,
            },
          }}
        />
      );
    }
    return (
      <div className="animated fadeIn">
        <div className="O-V-boarder">
          <>
            <div className="O-V-heading-bar">
              <div className="col-md-4 mt-1">
                {/* <CardHeader className="card-header-OverviewReimburseEmployee"> */}
                <strong>
                  <h4> Employee Payments Overview</h4>
                </strong>
                {/* </CardHeader> */}
                <Form>{/* {leaveData} */}</Form>
              </div>
              <div className=" col-md-8 mt-1 ">
                <>
                  <div
                    style={{
                      textAlign: "right",
                      // marginTop:"0.5rem",
                    }}
                  >
                    <Link to="/EmployeeReimburse">
                      <button
                        class="btn btn-outline-success rounded-pill "
                        disabled={thisContex.state.rolesPermission}
                      >
                        <i class="fa fa-plus px-2 " aria-hidden="true" />
                        Employee Payment
                      </button>
                    </Link>
                  </div>
                </>
              </div>
            </div>
          </>

          <div className="animated fadeIn">
            <div className="rowStyling mt-1">
              <Col>
                <div>
                  {/* my main data table loaded after my 1st call by function of did mount getLeaveApplicationMain*/}
                  <div>
                    {isLoadedTableData ? (
                      <BootstrapTable
                        data={tableData}
                        striped
                        pagination
                        hover
                        search
                        tableHeaderClass="rpr_header"
                        tableBodyClass="rpr_body"
                        containerClass="rpr_container"
                        options={options}
                      >
                        <TableHeaderColumn
                          dataField="date"
                          dataAlign="center"
                          // dataFormat={indexN}
                          dataSort={true}
                          width="10%"
                        >
                          DATE PAID
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataField="name"
                          dataFormat={dueFormatorsText}
                          width="25%"
                          isKey={true}
                        >
                          EMPLOYEE
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataField="paid"
                          dataAlign="right"
                          width="10%"
                          dataFormat={dueFormatorsComma}
                        >
                          PAID
                        </TableHeaderColumn>

                        <TableHeaderColumn
                          dataAlign="center"
                          dataField="PAY_EMPLOYEE_ID"
                          width="20%"
                          dataFormat={this.orderDetHandler}
                        >
                          Action
                        </TableHeaderColumn>
                      </BootstrapTable>
                    ) : (
                      " Loading..."
                    )}
                  </div>
                </div>
                {activityModelIsOpen && (
                  <>
                    <Modal
                      show={activityModelIsOpen}
                      size="xl"
                      onHide={this.toggleActivityModel}
                      backdrop="static"
                    >
                      <Modal.Header
                        closeButton
                        onClick={this.toggleActivityModel}
                        className=" Creative-Invoice-header-styling"
                      >
                        <strong>
                          {" "}
                          <h4> Activity Logs </h4>{" "}
                        </strong>
                      </Modal.Header>
                      <Modal.Body className="">
                        <ActivityLogs
                          closeModel={"closeModel"}
                          rowData={getActivityByDocNo}
                          // activeName="Employee REIMBURSE"
                          activeName={"Employee Payment"}

                          // callBack={() => {
                          //   this.toggleActivityModel();
                          // }}
                        />
                      </Modal.Body>
                    </Modal>
                  </>
                )}

                <Modal
                  show={this.state.UpdateModal}
                  size="lg"
                  onHide={this.UpdateModal}
                  backdrop="static"
                >
                  <Modal.Header
                    closeButton
                    onClick={() => this.updateModalToggle()}
                    className="theme-card-header-color-blue"
                  >
                    <strong>
                      <h4>Reimburse Employee Update</h4>
                    </strong>
                  </Modal.Header>

                  <Modal.Body>
                    <Form onSubmit={this.handleSubmitEdit}>
                      {/*yeh past krna h*/}
                      <div className="row">
                        <div
                          className="col-md-6"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label style={{ fontWeight: "bold" }}>
                            Which Employee did you pay?
                          </Label>
                          <Select
                            value={employee}
                            onChange={this.handleChangeLovsSelect}
                            options={clientLov}
                            //  className="selectOption"
                            // className="form-control"
                            autoFocus
                            required
                            name="selectedOptionPhase"
                            placeholder={"-- Select --"}
                          />
                        </div>
                        <div
                          className="col-md-6"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label style={{ fontWeight: "bold" }}>
                            When Did You Pay?{" "}
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>
                          <Input
                            type="date"
                            className="form-control"
                            id="employeStartDate"
                            name="employeStartDate"
                            placeholder="employeStartDate"
                            required
                            value={employeStartDate}
                            // min={moment(new Date()).format("YYYY-MM-DD")}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="col-md-5">
                          <Label
                            style={{
                              fontWeight: "bold",
                            }}
                          >
                            How Much Did You Pay?{" "}
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>
                          <InputGroup className="mb-3">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="fa fa-dollar"></i>
                              </InputGroupText>
                            </InputGroupAddon>

                            <NumberFormat
                              name="pay"
                              className="form-control"
                              style={{ textAlign: "right" }}
                              thousandSeparator={true}
                              value={pay}
                              required
                              onChange={this.handleChange}
                            />
                          </InputGroup>
                        </div>
                        <div className="col-md-7"></div>
                        <div
                          className="col-md-6"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label style={{ fontWeight: "bold" }}>
                            Which bank account was it paid from?{" "}
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>

                          <Select
                            value={bank}
                            onChange={this.handleChangeLovsSelectBank}
                            options={bankCash}
                            autoFocus
                            required
                            name="bank"
                            placeholder={"-- Select --"}
                          />
                        </div>
                        <div
                          className="col-md-6"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label style={{ fontWeight: "bold" }}>
                            Remarks
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>

                          <Input
                            type="text"
                            value={remarks}
                            onChange={this.handleChange}
                            autoFocus
                            name="remarks"
                          />
                        </div>
                      </div>
                      <hr
                        style={{
                          border: "1px solid black",
                          marginTop: "7px",
                        }}
                      />
                      <FormGroup>
                        <Button type="submit" color="success" className="mr-1">
                          UPDATE
                        </Button>
                      </FormGroup>
                    </Form>
                  </Modal.Body>
                </Modal>
              </Col>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default OverviewEmployeeExpenses;
